import React from "react";
import { useNavigate } from "react-router";
import { Paper, List, ListItem, ListItemText } from "@mui/material";
import GenerateFeed from "./GenerateFeed";
import { ACTION, PERMISSIONS, usePermissions } from "../../../utils/permissions";

const ContentCuration = () => {
    // hooks
    const navigate = useNavigate();
    const { hasPermission } = usePermissions();
    const canViewGenres =
        hasPermission(PERMISSIONS.genre, ACTION.VIEW) ||
        hasPermission(PERMISSIONS.genre, ACTION.EDIT);

    const navigateToHome = () => {
        navigate("/content-curation-versions");
    };

    const navigateToLog = () => {
        navigate("/change-log");
    };

    const navigateToGenre = () => {
        navigate("/genre-management");
    };

    const navigateToPromoMapping = () => {
        navigate("/promo-video-management");
    };

    const navigateToYmal = () => {
        navigate("/ymal-management");
    };

    const navigateToBoostSearch = () => {
        navigate("/boost-search");
    };

    const navigateToOpenSearch = () => {
        navigate("/open-search-sync");
    };

    return (
        <div className="config-heading">
            <Paper
                elevation={3}
                sx={{
                    padding: "32px",
                    width: "100%",
                    maxWidth: 700,
                    margin: "0 auto",
                    backgroundColor: "rgba(17, 17, 42, 0.8)",
                    backdropFilter: "blur(10px)",
                    borderRadius: "16px",
                    border: "1px solid rgba(255, 255, 255, 0.1)",
                }}
            >
                <List>
                    <ListItem onClick={navigateToHome} className="todo-item">
                        <ListItemText
                            primary="Landing Pages"
                            primaryTypographyProps={{
                                fontWeight: "bold",
                                textAlign: "center",
                            }}
                        />
                    </ListItem>
                    <ListItem onClick={navigateToLog} className="todo-item">
                        <ListItemText
                            primary="Change Log"
                            primaryTypographyProps={{
                                fontWeight: "bold",
                                textAlign: "center",
                            }}
                        />
                    </ListItem>
                    {canViewGenres && (
                        <ListItem onClick={navigateToGenre} className="todo-item">
                            <ListItemText
                                primary="Genre Management"
                                primaryTypographyProps={{
                                    fontWeight: "bold",
                                    textAlign: "center",
                                }}
                            />
                        </ListItem>
                    )}
                    <ListItem
                        onClick={navigateToPromoMapping}
                        className="todo-item"
                    >
                        <ListItemText
                            primary="Promo Video Management"
                            primaryTypographyProps={{
                                fontWeight: "bold",
                                textAlign: "center",
                            }}
                        />
                    </ListItem>
                    <ListItem onClick={navigateToYmal} className="todo-item">
                        <ListItemText
                            primary="You May Also Like"
                            primaryTypographyProps={{
                                fontWeight: "bold",
                                textAlign: "center",
                            }}
                        />
                    </ListItem>
                    <ListItem
                        onClick={navigateToBoostSearch}
                        className="todo-item"
                    >
                        <ListItemText
                            primary="Boost Search"
                            primaryTypographyProps={{
                                fontWeight: "bold",
                                textAlign: "center",
                            }}
                        />
                    </ListItem>
                    <ListItem
                        onClick={navigateToOpenSearch}
                        className="todo-item"
                    >
                        <ListItemText
                            primary="OpenSearch Sync"
                            primaryTypographyProps={{
                                fontWeight: "bold",
                                textAlign: "center",
                            }}
                        />
                    </ListItem>
                    <GenerateFeed />
                </List>
            </Paper>
        </div>
    );
};

export default ContentCuration;
